<template>
  <section class="floor-2">
    <div class="floor-2-1">
      <div class="content-container">
        <h1 class="title">{{$t('home.serviceItems.h1')}}</h1>
        <div class="sub-title">{{$t('home.serviceItems.pin-yin')}}</div>
        <p class="desc">
          {{$t('home.serviceItems.desc01')}}<br/>{{$t('home.serviceItems.desc02')}}
        </p>
      </div>
    </div>
    <div class="floor-2-2">
      <div class="card-container">
        <div class="card-item card-item-01">
          <div class="card-item-header">
            <span class="iconfont icon-wuliuquanqiuwuliu"></span>
            <span>{{$t('home.serviceItems.item.first.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.first.text')}}
          </p>
        </div>
        <div class="card-item card-item-02">
          <div class="card-item-header">
            <span class="iconfont icon-wuliuwuliuyunshu"></span>
            <span>{{$t('home.serviceItems.item.second.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.second.text')}}
          </p>
        </div>
        <div class="card-item card-item-03">
          <div class="card-item-header">
            <span class="iconfont icon-wuliuchanpin"></span>
            <span>{{$t('home.serviceItems.item.third.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.third.text')}}
          </p>
        </div>
        <div class="card-item card-item-04">
          <div class="card-item-header">
            <span class="iconfont icon-zhihuiwuliu"></span>
            <span>{{$t('home.serviceItems.item.fourth.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.fourth.text')}}
          </p>
        </div>
        <div class="card-item card-item-05">
          <div class="card-item-header">
            <span class="iconfont icon-wuliupeisong-12"></span>
            <span>{{$t('home.serviceItems.item.fifth.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.fifth.text')}}
          </p>
        </div>
        <div class="card-item card-item-06">
          <div class="card-item-header">
            <span class="iconfont icon-wuliudingdan"></span>
            <span>{{$t('home.serviceItems.item.sixth.title')}}</span>
          </div>
          <p class="card-item-content">
            {{$t('home.serviceItems.item.sixth.text')}}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="less" scoped>
@import url('../../../assets/iconfont/iconfont.css');
.floor-2 {
  .floor-2-1 {
    height: 542px;
    background: url("../../../assets/images/home/index-bg-car01.webp") no-repeat;
    background-size: 100%;
    .content-container {
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      .title {
        margin: 0;
        padding: 48px 0 0 0;
        color: #ff5d1b;
        text-align: center;
        font-size: 32px;
      }
      .sub-title {
        margin: 8px 0 66px 0;
        font-size: 13px;
        color: #fafafa;
        text-align: center;
      }
      .desc {
        margin: 0;
        text-align: center;
        line-height: 24px;
        font-size: 13px;
        color: #fff;
      }
    }
  }

  .floor-2-2 {
    /* padding: 120px 0 240px; */
    position: relative;
    height: 857px;
    background: url("../../../assets/images/home/index-bg-02.webp") no-repeat;
    background-size: 100%;
    /* border: 1px solid transparent; */
    .card-container {
      margin: -180px auto 0;
      width: 1266px;
      height: 730px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      border-radius: 18px;
      background-color: #fff;
      box-shadow: 0 0 8px rgba(0, 0, 0, 0.15);
      .card-item {
        box-sizing: border-box;
        padding: 48px 24px 24px;
        width: 422px;
        height: 50%;
        color: #40404a;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        /* background-color: red; */
        .card-item-header {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          text-align: center;
          font-size: 22px;
          cursor: default;
          &:hover {
            color: #ff5d1b;
          }
          span:nth-child(1) {
            font-size: 48px;
            margin-bottom: 12px;
          }
        }
        .card-item-content {
          margin-top: 48px;
          font-size: 13px;
          line-height: 22px;
          // overflow: hidden;
          // white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .card-item-01 {
        border-top-left-radius: 18px;
        border-bottom: 1px solid #e5e5e5;
      }
      .card-item-02 {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
      }
      .card-item-03 {
        border-top-right-radius: 18px;
        border-bottom: 1px solid #e5e5e5;
      }
      .card-item-04 {
        border-bottom-left-radius: 18px;
      }
      .card-item-05 {
        border-left: 1px solid #e5e5e5;
        border-right: 1px solid #e5e5e5;
      }
      .card-item-06 {
        border-bottom-right-radius: 18px;
      }
    }
  }
}

</style>